import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';
import Icon from '@sv-support-sdk/ui-components/src/components/Media/Icon';
import Avatar, { IAvatarProps } from '@sv-support-sdk/ui-components/src/components/Media/Avatar';

import css from './style.module.scss';
import { $l } from '../../../../locales';
import Button from '../../Controls/Button';

interface IProps {
  children: ReactNode;
  date?: string;
  avatar?: IAvatarProps;
  type?: 'fromUser';
  className?: string;
  id?: string;
  error?: boolean;
  errorResend?: (uuid: string) => void;
  withReply?: boolean;
  replyAction?: () => void;
}

const Message: FC<IProps> = ({
  errorResend,
  children,
  error,
  date,
  id,
  type,
  avatar,
  className,
  withReply,
  replyAction,
}) => (
  <div
    id={id}
    className={classNames(css.message, { [css[`message_type_${type}`]]: type }, className)}
  >
    {avatar && (
      <div className={css.message__avatar}>
        <Avatar {...avatar} />
      </div>
    )}
    <div className={css.message__body}>
      <div className={css.message__block}>
        <div className={css.message__action}>
          {error && (
            <Button
              onClick={errorResend}
              icon="16--error"
              iconSize="16"
              radius="circle"
              variant="icon-background"
            />
          )}
        </div>
        <div className={css.message__content}>{children}</div>
        {withReply && (
          <div className={classNames(css.message__action, css.message__action_type_reply)}>
            <Button
              onClick={replyAction}
              icon="16--reply"
              iconSize="16"
              radius="circle"
              variant="icon-background"
            />
          </div>
        )}
      </div>
      {date && <div className={css.message__date}>{date}</div>}
      {error && <div className={css.message__error}>{$l('NOT_SENT')}</div>}
    </div>
  </div>
);

export default Message;
